<template>
    <div align="center" class="sidebar">
        <div class="sys-name">证书管理系统</div>
        <div style="margin-top: 40px"><img src="../assets/image/avatar.png"/></div>
        <div class="user-info">
           <div>{{user.name}}</div>
        </div>
        <div class="content">
            <div v-for="item in menus" :class="{'menu-item':true,'cur-item':aciveInd==item.index}"  @click="go(item)" style="padding-left: 30px;">
                <div style="float: left;width: 20px" align="center"><i :class="`fa ${item.icon}`"></i></div>
                <div style="float: left">{{item.name}}</div>
                <div class="clear"></div>
            </div>
        </div>

        <div style="position: fixed;right: 30px;top: 5px;font-size: 30px;color:#409EFF">
            <i class="fa fa-sign-out" slot="reference" style="cursor: pointer;float: left" @click="logout">
                <span style="font-size: 15px;position: relative;top: -6px;margin-left: 3px">退出</span>
            </i>
            <div class="clear"></div>
        </div>
    </div>
</template>

<script type="application/ecmascript">
    export default {
        name: 'sidebar',//侧边栏 230px
        data () {
            return {
                menus: [
                    {name:'网站管理',path:'/',icon:'fa-table',index:'1'},
                    {name:'用户管理',path:'/user',icon:'fa-user',index:'2'},
                ],
                aciveInd:'',
                user:JSON.parse(localStorage.user),
            }
        },
        async mounted() {
            this.matchActive();
        },
        watch: {
            "$route": "matchActive",
        },
        methods:{
            matchActive(){
                for (let i = 0; i < this.menus.length; i++) {
                    let obj = this.menus[i];
                    if(obj.path == sessionStorage.toPath) return this.aciveInd = obj.index;
                }
            },
            go(item){
                if(item.index == this.aciveInd) return;
                this.aciveInd = item.index;
                this.$router.push({path:item.path})
            },
            logout(){
                localStorage.clear();
                this.$router.push({path:'/login'});
            },
        }
    }
</script>

<style scoped>
    .sidebar{
        width: 150px;height: 100vh; padding: 0 10px;color:#F8F9FA;float: left;
        background-image :url('../assets/image/sidebar-bg.png');background-size:100% 100%;

    }
    .sys-name{
        margin-top: 20px;font-size:20.22px;font-weight:bold;
    }
    .user-name{
        font-size:15px;font-weight:bold;margin: 20px 0 15px 0;
    }
    .user-info{
        font-weight:400;margin: 10px 0;font-family: 黑体;font-size: 18.22px;
    }
    .menu-item{
       padding: 20px;border-radius: 5px;cursor: pointer;
    }
    .menu-item .fa{
        margin-right: 10px;
    }
    .cur-item{
        background:#8dc4fc;cursor:default;
    }
    .copy-right{
        text-align:center;position:absolute; bottom:20px; color:#fff;width: calc(100% - 20px);text-align: center;
    }
    .content{
        height: calc(100vh - 260px);
        overflow-y: auto;
        text-align: left;
    }
</style>